import { render } from "./WDataTableSkeleton.vue?vue&type=template&id=172d5bfe&ts=true"
import script from "./WDataTableSkeleton.vue?vue&type=script&lang=ts"
export * from "./WDataTableSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__